import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tibao-2-qxjgd",
  "use": "icon-tibao-2-qxjgd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tibao-2-qxjgd\"><defs><style type=\"text/css\"></style></defs><path d=\"M513.024 344.064v-161.28l-315.392 286.208 315.392 286.208v-173.056c87.552 0 358.4 0 475.136 267.776v-29.696c0-119.296-116.736-501.248-475.136-476.16z\" fill=\"\" p-id=\"6302\" /><path d=\"M317.44 750.08l35.328-34.304-253.952-246.784 253.952-246.784-35.328-34.304-289.28 281.088 289.28 281.088z\" fill=\"\" p-id=\"6303\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol